import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    this.isDownloading = false
  }

  download(event) {
    // Prevent multiple clicks during download
    if (this.isDownloading) {
      event.preventDefault()
      return
    }

    this.isDownloading = true

    // Show loading state
    this.showLoading()

    // Let the link work normally, but hide spinner after a delay
    setTimeout(() => {
      this.hideLoading()
      this.isDownloading = false
    }, 10000) // Hide after 10 seconds
  }

  showLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove('d-none')
    }
  }

  hideLoading() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add('d-none')
    }
  }
}
